/**
 * @param {类型} window.TAnalyticsfixedData 对象, 已经定义在main.js里
 * @param {参数} sData 对象， 需要提交的参数
 */
export const TAnalytics = (sData = {}) => {
	let analyticsCreator = {
		serverUrl: 'https://web.xinyue.qq.com/xya',
		options: null,
		loadTime: null,
		hashFlagTime: null,
		init: () => {
			setTimeout(() => {
				analyticsCreator.initData();
				analyticsCreator.initOptions();
				analyticsCreator.initEvents();
				if (analyticsCreator.options.isspa) {
					analyticsCreator.initHashChangeEvent()
				}
				analyticsCreator.sendEnter();
				analyticsCreator.sendPageStayTime();
			}, 50)
		},
		initOptions: () => {
			analyticsCreator.options = {
				dataid: window.TAnalyticsfixedData.dataid,
				apiid: window.TAnalyticsfixedData.apiid,
				isspa: window.TAnalyticsfixedData.isspa || 1,
				activityid: window.TAnalyticsfixedData.activityid,
				businessid: window.TAnalyticsfixedData.businessid || 1005,
				sgameid: window.TAnalyticsfixedData.sgameid
			}
			if (!(analyticsCreator.options.dataid && analyticsCreator.options.isspa && analyticsCreator.options.apiid && analyticsCreator.options.activityid)) {
				if (console && console.error) {
					console.error('dataid and isspa and apiid and activityid is required prop in script\'s prop')
				}
			}
		},
		initData: () => {
			analyticsCreator.loadTime = (new Date()).getTime()
			analyticsCreator.hashFlagTime = this.loadTime
		},
		moloGetCookie: (sName, sDefaultValue) => {
			let sRE = '(?:; |^)' + sName + '=([^;]*);?'
			let oRE = new RegExp(sRE)
			if (oRE.test(document.cookie)) {
				return unescape(RegExp['$1'])
			} else {
				return sDefaultValue || null
			}
		},
		getBaseData: () => {
			let xyuin = ''
			let sessionId = ''
			let loginType = ''
			let isLogined = analyticsCreator.moloGetCookie('IED_LOG_INFO2') ? analyticsCreator.unSerialize(analyticsCreator.moloGetCookie('IED_LOG_INFO2')) : ''
			if (!isLogined || isLogined === '') {
				isLogined = analyticsCreator.moloGetCookie('IED_LOG_INFO2_QC') ? analyticsCreator.unSerialize(analyticsCreator.moloGetCookie('IED_LOG_INFO2_QC')) : ''
			}
			if (!isLogined || isLogined === '') {} else {
				if (isLogined.loginType === 'wx') {
					sessionId = analyticsCreator.utils.getCookie('access_token')
					xyuin = isLogined.openid
					loginType = 2
				} else if (isLogined.loginType === 'qc') {
					sessionId = analyticsCreator.utils.getCookie('access_token')
					xyuin = isLogined.openid
					loginType = 3
				} else {
					sessionId = analyticsCreator.utils.getCookie('skey')
					let uin = analyticsCreator.utils.getCookie('uin')
					xyuin = uin ? uin.replace(/^((o0)|(o))/, '') : ''
					loginType = 1
				}
				let userAgent = window.navigator.userAgent
				let sysid = 3
				if (/Android/i.test(navigator.userAgent)) {
					sysid = 1
				} else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
					sysid = 2
				}
				let connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection
				let nettype = (connection && connection.type) ? connection.type : ''
				switch (nettype) {
				case 'wifi':
					nettype = 1;
					break;
				case 'cellular':
					nettype = 6;
					break;
				case 'ethernet':
					nettype = 7;
					break;
				default:
					nettype = 8
				}
				let channelid = 1
				if (/tgclub/ig.test(navigator.userAgent.toLowerCase())) {
					channelid = 1
				} else if (/mqqbrowser/ig.test(navigator.userAgent.toLowerCase())) {
					channelid = 10
				} else if (/mqqbrowser/ig.test(navigator.userAgent.toLowerCase())) {
					channelid = 11
				} else {
					channelid = 0
				}
				let url = window.location.href
				let referrer = document.referrer
				let that = analyticsCreator;
				let tempRs = {
					xyuin: xyuin,
					sysid: sysid,
					logintype: loginType,
					useragent: userAgent,
					sessionid: sessionId,
					nettype: nettype,
					url: url,
					referrer: referrer,
					itemtype: window.TAnalyticsfixedData.itemtype || '1001',
					dataid: that.options.dataid,
					activityid: that.options.activityid,
					businessid: that.options.businessid,
					channelid: channelid
				}
				let rs = {}
				for (let key in tempRs) {
					if (tempRs[key] || tempRs[key] === 0) {
						rs[key] = tempRs[key]
					}
				}
				return rs
			}
		},
		getCommitCacheData: (params) => {
			let baseClonedData = analyticsCreator.getBaseData()
			if (typeof (baseClonedData) === 'undefined') {
				return {}
			}
			if (!params) {
				return baseClonedData
			}
			let keys = ['eventtype', 'itemid', 'giftid', 'moduleid', 'ext', 'gopenid', 'staytime', 'appid', 'customid', 'itemtype', 'logintype', 'sessionid']
			for (let i = 0; i < keys.length; i++) {
				let key = keys[i]
				// itemtype可以传空串 => ""
				if (key === 'itemtype' && !params[key] && typeof params[key] === 'string' && params[key].length === 0) {
					baseClonedData[key] = params[key]
				}
				// 其他情况不能为空
				if (typeof (params[key]) !== 'undefined') {
					baseClonedData[key] = params[key]
				}
				if (typeof window.TAnalyticsfixedData.pageid !== 'undefined' && window.TAnalyticsfixedData.pageid) {
					baseClonedData['pageid'] = window.TAnalyticsfixedData.pageid
				}
			}
			return baseClonedData
		},
		commit: (params) => {
			if (typeof (params['eventtype']) === 'undefined') {
				params['eventtype'] = '1002'
			}
			let commitData = analyticsCreator.getCommitCacheData(params);
			console.log(commitData)
			analyticsCreator.utils.sendData(commitData);
		},
		initEvents: () => {
			let that = analyticsCreator;
			if (!analyticsCreator.options.isspa) {
				window.onbeforeunload = () => { // 'pagestaytime', 'eventid', 'businessid', {pagestaytime:((new Date()).getTime() - that.loadTime)}
					let stayCommitData = that.getStayTimeParams(((new Date()).getTime() - that.loadTime))
					let storeData = that.getCommitCacheData(stayCommitData)
					that.utils.addItemsToVisitTimeList(storeData)
				}
			} else {
			// 由于vue-router较新版路由切换时无法触发浏览器的onhashchange事件，故采用模拟事件
				window.onmyhashchange = function (evt) { // 'pagestaytime', 'eventid', 'businessid', {pagestaytime:(curTime - that.hashFlagTime)}
					let curTime = (new Date()).getTime()
					let stayCommitData = that.getStayTimeParams(curTime - that.hashFlagTime)
					let storeData = that.getCommitCacheData(stayCommitData)
					// 需要取跳转前的url
					storeData.url = evt.oldURL
					that.utils.addItemsToVisitTimeList(storeData)
					that.hashFlagTime = curTime
					that.sendPageStayTime()
					that.sendEnter()
				}
				window.onbeforeunload = function () {
					let curTime = (new Date()).getTime()
					let stayCommitData = that.getStayTimeParams(curTime - that.hashFlagTime)
					let storeData = that.getCommitCacheData(stayCommitData)
					that.utils.addItemsToVisitTimeList(storeData)
				}
			}
		},
		initHashChangeEvent: () => {
			let location = window.location
			let oldURL = location.href
			let oldHash = location.hash
			// 每隔100ms检测一下location.hash是否发生变化
			setInterval(function () {
				let newURL = location.href
				let newHash = location.hash
				// 如果hash发生了变化,且绑定了处理函数...
				if (newHash !== oldHash && typeof window.onmyhashchange === 'function') {
					// execute the handler
					window.onmyhashchange({
						type: 'hashchange',
						oldURL: oldURL,
						newURL: newURL
					})
					oldURL = newURL
					oldHash = newHash
				}
			}, 100)
		},
		getStayTimeParams: (stayTime) => {
			let stayData = {
				staytime: stayTime
			}
			let pageParamSetting = null
			if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.pageParamSetting) {
				pageParamSetting = window.TAnalyticsfixedData.pageParamSetting
			} else {
				pageParamSetting = {}
			}
			analyticsCreator.utils.mergeBToA(stayData, pageParamSetting);
			return stayData
		},
		sendEnter: () => {
			if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.disableAutoSendEnter) {
				return
			}
			let that = analyticsCreator;
			setTimeout(function () {
				if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.disableAutoSendEnter) {
					return
				}
				let preData = { eventtype: '1001' };
				let pageParamSetting = null;
				if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.pageParamSetting) {
					pageParamSetting = window.TAnalyticsfixedData.pageParamSetting
				} else {
					pageParamSetting = {}
				}
				that.utils.mergeBToA(preData, pageParamSetting);
				that.utils.sendData(that.getCommitCacheData(preData))
			}, 200)
		},
		sendPageStayTime: () => {
			if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.disableAutoSendStayTime) {
				return
			}
			let pageStayTimeList = analyticsCreator.utils.getVisitTimeListFromLocalStorage();
			if (pageStayTimeList.length) {
				for (let i = 0; i < pageStayTimeList.length; i++) {
					analyticsCreator.utils.sendData(pageStayTimeList[0])
				}
			}
			analyticsCreator.utils.clearPageVisitTimeList()
		},
		unSerialize: (jsonStr, de) => {
			de = de || 0;
			jsonStr = jsonStr.toString();
			if (!jsonStr) return {};
			let retObj = {}
			let obj1Ret = jsonStr.split('&')
			if (obj1Ret.length === 0) return retObj
			for (let i = 0; i < obj1Ret.length; i++) {
				if (!obj1Ret[i]) continue
				let ret2 = obj1Ret[i].split('=')
				if (ret2.length >= 2) {
					let ret0 = obj1Ret[i].substr(0, obj1Ret[i].indexOf('='))
					let ret1 = obj1Ret[i].substr(obj1Ret[i].indexOf('=') + 1);
					if (!ret1) ret1 = ''
					if (ret1.indexOf('#') > -1) {
						ret1 = ret1.split('#')[0]
					}
					if (ret0) retObj[ret0] = de === 0 ? decodeURIComponent(ret1) : ret1
				}
			}
			return retObj
		},
		utils: {
			trim: (str) => {
				return str ? str.replace(/^\s+|\s+$/gm, '') : str
			},
			getCookie: (key) => {
				let reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
				let arr = document.cookie.match(reg)
				if (arr) {
					return arr[2]
				} else {
					return null
				}
			},
			getJsonCookie: () => {
				let that = this
				let cookieStr = document.cookie;
				if (cookieStr) {
					return '{' + cookieStr.split(';').map((item) => {
						let idx = item.indexOf('=')
						let arr = item.split('=')
						let key = that.trim(arr[0]);
						let value = idx + 1 < item.length ? that.trim(item.substring(idx + 1)) : '';
						return '"' + key + '":"' + value + '"'
					}).join(',') + '}'
				} else {
					return '{}'
				}
			},
			mergeBToA: (a, b) => {
				if (b && a) {
					for (var key in b) {
						a[key] = b[key]
					}
				}
			},
			sendData: (params) => {
				params.time = (new Date()).getTime();
				var rqImg = new Image(1, 1);
				rqImg.src = analyticsCreator.serverUrl + '?params=' + encodeURIComponent(JSON.stringify(params)) + '&id=' + encodeURIComponent(analyticsCreator.options.apiid)
			},
			getVisitTimeListFromLocalStorage: function () {
				let list = localStorage.getItem('visit_time_list');
				if (list) {
					return JSON.parse(list)
				} else {
					return []
				}
			},
			addItemsToVisitTimeList: function (items) {
				if (window.TAnalyticsfixedData && window.TAnalyticsfixedData.disableAutoSendStayTime) {
					analyticsCreator.utils.clearPageVisitTimeList()
					return
				}
				if (!items) {
					return
				}
				var list = analyticsCreator.utils.getVisitTimeListFromLocalStorage();
				if (items instanceof Array) {
					list = list.concat(items)
				} else {
					list.push(items)
				}
				localStorage.setItem('visit_time_list', JSON.stringify(list))
			},
			clearPageVisitTimeList: () => {
				if (!analyticsCreator.utils.getVisitTimeListFromLocalStorage().length) {
					return
				}
				localStorage.setItem('visit_time_list', JSON.stringify([]))
			}
		}
	}
	analyticsCreator.init()
	setTimeout(function () {
		analyticsCreator.commit(sData)
	}, 60)
}



// WEBPACK FOOTER //
// ./src/utils/tanalytics.js